const faqs = [
  {
    question: "Does Michigan have its own passport agency?",
    answer:
      "Michigan has one regional passport agency: the Detroit Passport Agency (211 W. Fort St, Suite 1300, Detroit, MI 48226). It requires appointments and proof of travel within 14 days (or 28 days with a visa application). Given Michigan's geographic size, many travelers — especially from the Upper Peninsula and Northern Michigan — find that using an approved courier like Fast Passport Center is significantly faster than traveling to Detroit.",
  },
  {
    question: "How fast can I get a passport in Michigan?",
    answer:
      "With Fast Passport Center's courier service, Michigan travelers can receive a passport in as little as 24 hours. Our standard expedited service ranges from 3 to 9 business days. Routine processing through the post office typically takes 6 to 13 weeks. Given Michigan's harsh winters and high volume of tropical travel (January through March), expedited services are especially popular in the Detroit metro, Grand Rapids, and Ann Arbor areas.",
  },
  {
    question: "Do I need to visit a passport acceptance facility in Michigan?",
    answer:
      "First-time applicants, minors under 16, and those replacing lost or stolen passports must visit an acceptance facility (typically a post office, county clerk, or library). Michigan has hundreds of acceptance facilities across the state, including many in the Upper Peninsula. Renewals for adults with a passport issued within the last 15 years can usually be done by mail without an in-person visit.",
  },
  {
    question: "Which Michigan airport should I fly from with an expired passport?",
    answer:
      "If your passport is expired or soon to expire, you should not book international travel until you have a valid passport in hand. Major Michigan international airports include Detroit Metro (DTW), Gerald R. Ford International (GRR), and Capital Region International (LAN). For northern Michigan, Cherry Capital (TVC) and Pellston (PLN) also offer international connections.",
  },
  {
    question: "Can I renew my passport by mail in Michigan?",
    answer:
      "Yes — if your most recent passport was issued when you were 16 or older, was issued within the last 15 years, is undamaged, and was issued in your current name (or you have legal documentation of a name change), you can renew by mail using Form DS-82. Mail your application to the National Passport Processing Center. For faster service, use an approved expedited courier.",
  },
  {
    question: "Do I need a passport for a Canada trip from Michigan?",
    answer:
      "Yes — a valid passport is required for all air travel to Canada. For land crossings (via the Ambassador Bridge, Blue Water Bridge, Detroit Windsor Tunnel, or Sault Ste. Marie International Bridge), U.S. citizens can use a passport card, enhanced driver's license, or Trusted Traveler card. However, a passport book is recommended for maximum flexibility. Children under 16 crossing by land with a birth certificate are typically accepted.",
  },
  {
    question: "What about Michigan cruise ship passengers?",
    answer:
      "For closed-loop cruises (beginning and ending at the same U.S. port), U.S. citizens can sometimes travel with a government-issued photo ID and birth certificate. However, having a valid passport is strongly recommended — if an emergency requires you to fly home from a port of call, you cannot board a flight without a passport. Many cruise lines now require passports regardless of itinerary.",
  },
  {
    question: "How do Upper Peninsula residents get passports quickly?",
    answer:
      "The Upper Peninsula is 8+ hours from the Detroit Passport Agency and over 6 hours from Chicago. For UP residents with urgent travel needs, Fast Passport Center's courier service is the fastest option — we hand-carry your application to a regional agency, eliminating the need for you to travel. Same-day and next-day service is available for travelers with confirmed flights within 72 hours.",
  },
];

export { faqs };

export default function MichiganFAQSection() {
  return (
    <section id="faq" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">FAQ</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Michigan Passport Questions
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Quick answers for travelers applying for passports across the Great Lakes State.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, i) => (
            <details
              key={i}
              className="group bg-white rounded-lg border border-gray-200 overflow-hidden"
            >
              <summary className="flex items-center justify-between cursor-pointer p-5 list-none">
                <span className="font-bold text-[#1A365D] text-sm pr-4">{faq.question}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                  <i className="ri-add-line text-[#1A365D] text-sm group-open:ri-subtract-line"></i>
                </div>
              </summary>
              <div className="px-5 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}